export const ADMIN = {
    id: 1000,
    name: "Admin",
    label: "Admin",
    info: ""
};

export const STUDIO = {
    id: 1001,
    name: "Studio",
    label: "Studio",
    info: ""
};

export const OPERATOR = {
    id: 1002,
    name: "Operator",
    label: "Operatore",
    info: ""
};

export const GROUP_ADMIN = {
    id: 1003,
    name: "GroupAdmin",
    label: "Admin Gruppo",
    info: ""
};

export const IDENTITY_ROLE = {
    id: 1004,
    name: "IdentityRole",
    label: "Ruolo e Permessi",
    info: "Permette di cambiare ruoli agli admin e di fare link/unlink di un admin e uno studio"
};

export const DOCUMENT = {
    id: 2000,
    name: "Document",
    label: "Documenti",
    info: "Usata solo per filtrare nelle GET, andrebbe propagata"
};

export const PRACTICE = {
    id: 2001,
    name: "Practice",
    label: "Pratiche",
    info: "Usata nelle api GET delle pratiche, andrebbe propagata alle altre api correlate"
};

export const CHAT = {
    id: 2002,
    name: "Chat",
    label: "Chat",
    info: "Usata solo nella Get Conversazioni, andrebbe propagata alle altre api di quel controller"
};
export const DASHBOARD = {
    id: 2003,
    name: "Dashboard",
    label: "Dashboard",
    info: "Permette la visione delle dashboard"
};

export const CHATBOT = {
    id: 2004,
    name: "Chatbot",
    label: "Chatbot",
    info: "Componente chatbot"
};

export const SERVICES = {
    id: 2005,
    name: "Services",
    label: "Servizi",
    info: "Componente servizi"
};

export const COMPANY = {
    id: 2006,
    name: "Company",
    label: "Azienda",
    info: "Gestione delle aziende"
};

export const PROMPT = {
    id: 2007,
    name: "Prompt",
    label: "Prompt",
    info: "Gestione prompt"
};
export const MANAGEMENT_USERS = {
    id: 2008,
    name: "ManagementUsers",
    label: "Gestione Utenti",
    info: "Associarlo alla gestione degli utenti"
};
export const MANAGEMENT_OPERATORS = {
    id: 2009,
    name: "ManagementOperators",
    label: "Gestione Operatori",
    info: "Gestione operatori"
};

export const MANAGEMENT_STUDIOS = {
    id: 2010,
    name: "ManagementStudios",
    label: "Gestione Studi",
    info: "Gestione studi"
};

export const DEADLINES = {
    id: 2011,
    name: "Deadlines",
    label: "Scadenze",
    info: "Gestione e creazione delle scadenze"
};

export const EXCATEGORIES = {
    id: 2012,
    name: "ExCategories",
    label: "Classificatore",
    info: "Gestione delle categorie dell'analisi documentale"
};

export const NEWS = {
    id: 2013,
    name: "News",
    label: "News",
    info: "Gestione delle news"
};

export const ALL_CAPABILITIES = [
    ADMIN,
    STUDIO,
    OPERATOR,
    GROUP_ADMIN,
    IDENTITY_ROLE,
    DOCUMENT,
    PRACTICE,
    CHAT,
    CHATBOT,
    SERVICES,
    COMPANY,
    MANAGEMENT_OPERATORS,
    MANAGEMENT_STUDIOS,
    PROMPT,
    MANAGEMENT_USERS,
    DASHBOARD,
    DEADLINES,
    EXCATEGORIES,
    NEWS
];

export const CAPABILITIES_ROLE = [
    ADMIN,
    STUDIO,
    OPERATOR,
    GROUP_ADMIN,
];

export const PRESET_ADMIN = [
    IDENTITY_ROLE,
    DOCUMENT,
    PRACTICE,
    CHAT,
    CHATBOT,
    SERVICES,
    COMPANY,
    MANAGEMENT_OPERATORS,
    MANAGEMENT_STUDIOS,
    PROMPT,
    MANAGEMENT_USERS,
    DASHBOARD,
    DEADLINES,
    EXCATEGORIES,
    NEWS
];

export const PRESET_STUDIO = [
    DOCUMENT,
    PRACTICE,
    CHAT,
    CHATBOT,
    SERVICES,
    COMPANY,
    MANAGEMENT_OPERATORS,
    MANAGEMENT_USERS,
    DASHBOARD,
    DEADLINES,
    NEWS
];

export const PRESET_OPERATOR = [
    DOCUMENT,
    PRACTICE,
    CHAT,
    CHATBOT,
    SERVICES,
    MANAGEMENT_USERS,
    DASHBOARD,
    DEADLINES,
    NEWS
];

export const PRESET_ADMINGOUP = [
    DOCUMENT,
    PRACTICE,
    CHAT,
    CHATBOT,
    SERVICES,
    COMPANY,
    MANAGEMENT_OPERATORS,
    MANAGEMENT_STUDIOS,
    MANAGEMENT_USERS,
    DASHBOARD,
    DEADLINES,
    NEWS
];


